import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import type {PhotoCheckerSilhouetteVariant} from '../types/PhotoCheckerSilhouetteVariant';

interface PhotoCheckerMarkerIconProps {
  variant: PhotoCheckerSilhouetteVariant;
  x: number;
  y: number;
  size: number;
}

export function PhotoCheckerMarkerIcon(props: PhotoCheckerMarkerIconProps) {
  const scale = props.size / 20;
  const path = match<PhotoCheckerSilhouetteVariant, string | null>(props.variant)
    .with(
      'pass',
      () =>
        'M7.95837 15L3.20837 10.25L4.39587 9.062L7.95837 12.625L15.6042 4.979L16.7917 6.167L7.95837 15Z'
    )
    .with(
      'caution',
      () =>
        'M11.177 14.656C11.503 14.983 11.667 15.375 11.667 15.833C11.667 16.292 11.503 16.684 11.177 17.01C10.851 17.337 10.458 17.5 10 17.5C9.542 17.5 9.149 17.337 8.823 17.01C8.496 16.684 8.333 16.292 8.333 15.833C8.333 15.375 8.496 14.983 8.823 14.656C9.149 14.33 9.542 14.167 10 14.167C10.458 14.167 10.851 14.33 11.177 14.656ZM11.25 2.5L11.25 12.5H8.75L8.75 2.5H11.25Z'
    )
    .with(
      'fail',
      () =>
        'M5.333 15.8337L4.167 14.667L8.833 10.0003L4.167 5.3337L5.333 4.167L10 8.8337L14.667 4.167L15.833 5.3337L11.167 10.0003L15.833 14.667L14.667 15.8337L10 11.167L5.333 15.8337Z'
    )
    .with(
      'missing',
      () =>
        'M5.333 15.8337L4.167 14.667L8.833 10.0003L4.167 5.3337L5.333 4.167L10 8.8337L14.667 4.167L15.833 5.3337L11.167 10.0003L15.833 14.667L14.667 15.8337L10 11.167L5.333 15.8337Z'
    )
    .with('plain', () => null)
    .exhaustive();

  if (isNil(path)) {
    return null;
  }

  return (
    <path d={path} fill="white" transform={`translate(${props.x}, ${props.y}) scale(${scale})`} />
  );
}
